<template>
  <div class="demo-vertical-spacing">
    <!-- basic search -->
    <b-input-group class="input-group-merge d-block text-center">
      <h4>Hola, usted esta solicitando una aclaración sobre la siguiente evaluación: </h4>
      <small
        class="text-muted"
        style="letter-spacing: 0.3em;"
      >Parcial: <b class="text-primary"> #{{ calif.numParcial }}</b>, Evaluación: <b class="text-primary">{{ calif.calif_profesor }}</b>, Periodo: <b class="text-primary">{{ periodoxmateria }}</b></small>
    </b-input-group>
    <b-input-group
      prepend="Argumento:"
      class="input-group-merge"
    >
      <b-form-textarea
        v-model="argumento"
        size="sm"
      />
    </b-input-group>
    <small class="mt-1 text-center">Explique los motivos de su solicitud.</small>
    <div class="d-block mt-2 text-center">
      <b-button
        v-show="flagtramitado == false"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="mr-2"
        type="submit"
        @click="sendAclaracion()"
      >
        <b-spinner
          v-show="flagproceder"
          small
          type="grow"
        />
        {{ (flagproceder) ? 'Trabajando...': 'Enviar Solicitud' }}
      </b-button>
      <b-alert
        v-show="flagtramitado"
        show
        variant="info"
      >
        <div class="alert-body">
          <feather-icon
            class="mr-25"
            icon="AlertTriangleIcon"
          />
          <span class="ml-25">Esta solicitud ya fue enviada.</span>
        </div>
      </b-alert>
    </div>
  </div>
</template>
<script>
import {
  BInputGroup,
  BButton,
  BFormTextarea,
  BSpinner,
  BAlert,
} from 'bootstrap-vue'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ref, computed } from '@vue/composition-api'
import store from '@/store'
import Ripple from 'vue-ripple-directive'
import {
  formhttp,
} from '@core/utils/utils'

export default {
  components: {
    BInputGroup,
    BButton,
    BFormTextarea,
    BSpinner,
    BAlert,
  },
  directives: {
    Ripple,
  },
  props: {
    calif: {
      type: Object,
      default: () => {},
    },
    periodoxmateria: {
      type: Number,
      default: () => 0,
      required: true,
    },
  },
  data() {
    return {
      aclaracion: '',
    }
  },
  setup(props) {
    const flagproceder = ref(false)
    const flagtramitado = ref(false)
    const toast = useToast()
    const argumento = ref('')

    const pack = computed(() => {
      const dataReturn = {
        task: 'wscomitehonor',
        action: 1,
        data: {
          periodo: props.periodoxmateria, calif_id: props.calif.id, solicita: 'ALU', argumento: null,
        },
      }
      return dataReturn
    })

    // enviar aclaracion de evaluacion
    const sendAclaracion = () => {
      if (argumento.value.length > 10) {
        flagproceder.value = true
        pack.value.data.argumento = argumento.value
        // format obj json valid
        pack.value.data = JSON.stringify(pack.value.data)

        store.dispatch('compras/postCompras', pack.value)
          .then(response => {
            const { icon, label } = formhttp(response.status)
            toast({
              component: ToastificationContent,
              props: {
                title: 'Atención',
                text: response.message,
                icon,
                variant: label,
              },
            },
            { timeout: 8000 })
            if (response.status === 200) {
              flagtramitado.value = true
              argumento.value = ''
            }
            flagproceder.value = false
          }, error => {
            flagproceder.value = false
            toast({
              component: ToastificationContent,
              props: {
                title: 'Error en petición [Autorizar solicitud]',
                text: error,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          })
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: 'Informacion incompleta, ingrese el argumento de su solicitud.',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 10000 })
      }
    }

    return {
      // flags
      flagproceder,
      sendAclaracion,
      pack,
      argumento,
      flagtramitado,

    }
  },
}
</script>
